import { briefs } from '@/mocks/homeData';

export default function Briefs() {
  return (
    <section id="briefs" className="scroll-mt-24 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="font-label text-xs font-semibold uppercase tracking-[0.3em] text-accent-700"># 滚动 · 快讯流</p>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              短讯连发，<span className="text-primary-600">不漏一条</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">标题 + 一句话摘要，扫一眼就知道这瓜要不要吃。</p>
          </div>
          <span className="inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-4 py-2 text-xs font-medium text-foreground-500">
            <span className="h-2 w-2 animate-pulse rounded-full bg-accent-500" />
            今日已更新 18 条
          </span>
        </div>

        {/* 图文并重：紧凑卡片并行 */}
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {briefs.map((b) => (
            <a
              key={b.title}
              href="#community"
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition hover:border-primary-200"
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={b.img}
                  alt={b.title}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex items-center gap-1 rounded-md bg-primary-950/85 px-2.5 py-1 text-[11px] font-bold text-accent-400 backdrop-blur">
                  {b.badge}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-medium leading-snug text-foreground-950 transition group-hover:text-primary-700">
                  {b.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{b.summary}</p>
                <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1.5">
                    <span className="rounded bg-secondary-100 px-1.5 py-0.5 font-medium text-secondary-700">{b.tag}</span>
                    <span>{b.time}</span>
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" /> {b.reads}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}